let nextId = 1000;

export const numericIdFactory = () => nextId++;